import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Settings from '@/pages/Settings.vue'
import Link from '@/pages/Link.vue'

import Transactions from '@/pages/Transactions.vue'
import TransactionsDetail from '@/pages/Transactions/Detail.vue'

import Logout from '@/pages/Logout.vue'





const routes = [
	{
		path: '/link/:chat_id',
		name: "ភ្ជាប់គណនីតេឡេក្រាម",
		component: Link,
	},
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				name: "ផ្លាស់ប្តូរពាក្យសំងាត់",
				component: Settings,
			},
			{
				path: 'transactions',
				name: "",
				component: Transactions,
			},
			{
				path: 'transactions/:hash_id',
				name: "",
				component: TransactionsDetail,
			},
			{
				path: 'logout',
				name: "ចាកចេញ",
				component: Logout,
			}
		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js